import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Input, Form, Select, DatePicker } from 'components/shared/FormComponent';
import { Empty, message, Spin, Table, Tooltip } from 'components/shared/AntComponent';
import SearchIcon from 'assets/img/search.svg';
import { DeleteFilled } from 'components/shared/AntIcons';
import { Button } from 'components/shared/ButtonComponent';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { addNotificationCenter } from 'services/actions/notificationCenterAction';

const { TextArea } = Input;
const CreateNotification: React.FC = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { loading1, success1, error1 } = useSelector((state: any) => state.notifyCenter);
    const [form] = Form.useForm();
    const editor: any = useRef(null);
    const [content, setContent] = useState('');
    const [tags, setTags]: any = useState([]);
    const [showSuccessmsg, setShowSuccessmsg] = useState(false);
    const successmsg = showSuccessmsg ? success1 : false;
    const [showErrormsg, setShowErrormsg] = useState(false);
    const errormsg = showErrormsg ? error1 : false;
    // console.log("location", location.state);
    const handleBack = () => {
        navigate('/notification-center')
    }

    const submitForm = (values: any) => {
        const inputJson = {
            "notificationid": location?.state?.id || 0,
            "title": values?.notificationTitle || "",
            "start_date": values['startDate'].format('YYYY-MM-DD') || "",
            "end_date": values['endDate'].format('YYYY-MM-DD') || "",
            "description": values?.description || ""
        }
        // console.log("inputJson", inputJson);
        dispatch(addNotificationCenter(inputJson) as any);
        setShowErrormsg(true);
        setShowSuccessmsg(true);
    }

    const statusOptions = [
        { label: "Active", value: 'active' },
        { label: "Inactive", value: "inactive" },
        { label: "Closed", value: "closed" }
    ];

    const disableDates = (current) => {
        return current && current < dayjs().startOf('day');
    };

    useEffect(() => {
        if (successmsg) {
            message.success("Notification created successfully");
            setShowSuccessmsg(false);
            navigate('/notification-center');
        }
        if (errormsg) {
            if (error1?.data) {
                message.error(error1?.data);
            } else {
                message.error("Notification couldn't be created");
            }
            setShowErrormsg(false);
        }
    }, [successmsg, errormsg]);

    const loadData = () => {
        if (location.state?.id !== 0) {
            const rowData = location?.state?.rowData || null;
            form.setFieldsValue({
                notificationTitle: rowData?.title || "",
                description: rowData?.description || "",
                startDate: rowData?.start_date ? dayjs(rowData?.start_date) : null,
                endDate: rowData?.end_date ? dayjs(rowData?.end_date) : null,
                status: rowData?.status || ''
            })

        } else {
            form.resetFields();
            form.setFieldsValue({ status: 'active' });
        }
    }

    useEffect(() => {
        if (location.state.id) {
            loadData();
        }
    }, [location.state]);

    return (
        <div className="p-3">
            <div className="d-flex grid-title-card">
                <h5 className="my-auto ">{location.state?.rowData ? "Update " : "Add "}Notification</h5>
                <div className="ms-auto d-flex title-btn">
                    <Button type="primary" onClick={handleBack} className="add-btn">
                        Back
                    </Button>
                </div>
            </div>
            {/* <div className='row' */}
            <div className="my-2 bg-white p-3 template-manager">
                <Form layout="vertical" form={form} onFinish={submitForm}>
                    <div className="row m-0">
                        <Form.Item name="notificationTitle" label="Notification Title" className='col-md-7' rules={[{ required: true, message: 'This field is required!' }]}>
                            <Input />
                        </Form.Item>
                        <Form.Item name="startDate" className='col' label="Start Date" rules={[{ required: true, message: 'This field is required!' }]}>
                            <DatePicker className="w-100" format="MM-DD-YYYY" disabledDate={disableDates} />
                        </Form.Item>
                        <Form.Item name="endDate" className='col' label="End Date" rules={[{ required: true, message: 'This field is required!' }]}>
                            <DatePicker className="w-100" format="MM-DD-YYYY" disabledDate={disableDates} />
                        </Form.Item>
                        <Form.Item name="status" className='col' label="Status" rules={[{ required: true, message: 'This field is required!' }]}>
                            <Select className='w-100' options={statusOptions} />
                        </Form.Item>
                    </div>
                    <div className="row mx-0">
                        <Form.Item name="description" label="Description">
                            <TextArea rows={5} />
                        </Form.Item>
                    </div>
                    <div className='d-flex align-items-center my-2 justify-content-end pe-2'>
                        <Button className='add-btn' htmlType='submit' type='primary' loading={loading1}>Save</Button>
                    </div>
                </Form>
            </div>
        </div>
    )
}

export default CreateNotification;